import {
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Switch,
  Modal,
  Dimensions,
  ActivityIndicator,
} from "react-native";
import { Text, View } from "../../../components/Themed";
import { jsonToCSV } from "react-native-csv";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { RootStackScreenProps } from "../../../types"; 
import React, { useEffect, useState } from "react";
import Icon from "react-native-vector-icons/AntDesign";
import { useFocusEffect } from "@react-navigation/native";
import IconCross from "react-native-vector-icons/Entypo";
import { postData } from "../../../networking/api";
import { Provider as PaperProvider } from "react-native-paper";
import IconEdit from "react-native-vector-icons/FontAwesome";
import { TextInput } from "react-native-paper";

import IconEye from "react-native-vector-icons/Entypo";
import { color } from "react-native-elements/dist/helpers";
import DataTable from "react-data-table-component";
import { PROVIDER_GOOGLE } from "react-native-maps";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function OmegaDevice({ navigation }) {
  const [text, setText] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  var [counter, setCounter] = useState(1);

  const [isLoading, setIsLoading] = useState(true);
  const [DeviceProfileDataLength, setDeviceProfileDataLength] = useState(0);
  const [DeviceProfileNameData, setDeviceProfileNameData] = useState([]);
  const [projectId, setProjectId] = useState("");

  const [searchData, setSearch] = useState("");
  const [filterData, setFilteredDataSource] = useState([]);
  const [isDeviceProfileNameDataValid, setDeviceProfileNameDataValid] =
    useState(false);
  const [isDeviceProfileNameDataEntered, setDeviceProfileNameDataEntered] =
    useState(false);
  const [sort, setsort] = useState(0);
  const [editpopup, setEditPopup] = useState(false);
  const [popid, setpopid] = useState("");
  const [popindex, setpopindex] = useState("");


  const customStyles = {
    rows: {
      style: {
        minHeight: "30px", 
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        minHeight: "20px",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", 
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
        },
      },
    },
  };
  const columns = [
    {
      name: "Sr.No",
      selector: (row) => row.id,

      width: "100px",
    },
    {
      name: "Omega name",
      selector: (row) => row.device_name,
      sortable: true,
    },
    {
      name: "Omega Number",
      selector: (row) => row.omega_id,
      sortable: true,
    },
    {
      name: "Assigned",
      selector: (row) => row.assigned,
      sortable: true,
    },
    {
      name: "Status",
      width: "100px",

      cell: (item, index) => (
        <Switch
          trackColor={{ false: "#767577", true: "#1DA1F2" }}
          thumbColor={item.active == 1 ? "#fff" : "#f4f3f4"}
          activeThumbColor="#fff"
          onValueChange={() => {
            setEditPopup(true);
            setpopid(item.id);
            setpopindex(index);
          }}
          value={item.active == 1 ? true : false}
        />
      ),
    },
  ];
  const toggleSwitch = () => {
    var tempIndex = DeviceProfileNameData.findIndex(
      (item) => item.id === popid,
    );

    if (DeviceProfileNameData[tempIndex].active == 1) {
      DeviceProfileNameData[tempIndex].active = 0;
      activeDeviceProfile(popid, 0);
    } else {
      DeviceProfileNameData[tempIndex].active = 1;
      activeDeviceProfile(popid, 1);
    }
    setDeviceProfileNameData(DeviceProfileNameData);
  };
  const optionsPerPage = [10, 25, 50, 100];

  const [page, setPage] = React.useState(0);
  const [itemsPerPage, setItemsPerPage] = React.useState(optionsPerPage[0]);
  const from = page * itemsPerPage;
  const to = Math.min((page + 1) * itemsPerPage, DeviceProfileDataLength);
  var idProject = useSelector((state) => state.idUpdating);

  React.useEffect(() => {
    setPage(0);
    setpopindex("");
    setEditPopup(false);
    setpopid("");
  }, [itemsPerPage]);

  useEffect(() => {
  }, [idProject]);

  useFocusEffect(
    React.useCallback(() => {
      getAdminData();

      searchFilterFunction("");
    }, []),
  );

  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    let projValue = await AsyncStorage.getItem("projectData");

    if (projValue != null) {
      setProjectId(projValue);
      getAllDeviceProfileData([], projValue);
    } else if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);

      setProjectId(userDetailsresponse.project_selected);
      getAllDeviceProfileData([], userDetailsresponse.project_selected);
    }
  };
  const searchFilterFunction = (text) => {
    if (text) {
      const newData = DeviceProfileNameData.filter(function (item) {
        const itemData = item.device_name
          ? item.device_name.toUpperCase()
          : "".toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
      setPage(0);
    } else {
      setFilteredDataSource(DeviceProfileNameData);
      setSearch(text);
      setPage(0);
    }
  };
  const activeDeviceProfile = async (cityId, isActive) => {
    setIsLoading(true);
    try {
      var DeviceProfileData = JSON.stringify({
        id: cityId,
        module: "devices_master",
        data: {
          active: isActive,
        },
      });
      const activeDeviceProfileResponse = await postData(
        DeviceProfileData,
        "masters/masterCreateUpdate",
      );

      setIsLoading(false);

      var code = activeDeviceProfileResponse.code;
      if (code == 1) {
        setIsVisible(false);
        getAllDeviceProfileData([], projectId);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const exportCsvDeviceProfileData = async () => {
    setIsLoading(true);
    try {
      var getDeviceProfileData = JSON.stringify({
        module: "devices_master",
      });
      const DeviceProfileNameResponse = await postData(
        getDeviceProfileData,
        "masters/exportFile",
      );
      setIsLoading(false);
      var code = DeviceProfileNameResponse.code;
      if (code == 1) {
        setDeviceProfileNameData(DeviceProfileNameResponse.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getAllDeviceProfileData = async (sortdata: never[], pid) => {
    setIsLoading(true);
    if (sortdata.length > 0) {
      setDeviceProfileDataLength(sortdata.length);
      setDeviceProfileNameData(sortdata);
      setFilteredDataSource(sortdata);
    } else {
      try {
        var getDeviceProfileData = JSON.stringify({

          project_id: pid,
          active: true,
        });
        const DeviceProfileNameResponse = await postData(
          getDeviceProfileData,
          "masters/getOmegaMasterlist",
        );
        setIsLoading(false);
        var code = DeviceProfileNameResponse.code;
        if (code == 1) {
          setDeviceProfileDataLength(DeviceProfileNameResponse.data.length);
          setDeviceProfileNameData(DeviceProfileNameResponse.data);
          setFilteredDataSource(DeviceProfileNameResponse.data);
          const results = jsonToCSV(DeviceProfileNameResponse.data);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error", error);
      }
    }
  };

  const downloadExcelReport = async () => {
    const filteredData = DeviceProfileNameData.map(
      ({ device_name, omega_id, active }, index) => ({
        "Sr No": index + 1,
        "Omega Name": device_name,
        "Omega Number": omega_id,
        Active: active == 1 ? "Active" : "InActive",
      }),
    );
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      type: "array",
      bookType: "xlsx",
    });
    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(excelData, "omega_devices_master.xlsx");
  };
  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;
  return (
    <View style={styles.container}>
      <View
        style={
          isMobile
            ? { width: "100%", marginTop: 200 }
            : { flexDirection: "row", width: "100%", marginTop: "10%" }
        }
      >
        <View style={{ flex: 0.2, margin: 10 }}>
          <Text style={styles.lableText}>Master {">"} Omega Devices</Text>
        </View>
        <Modal
          visible={editpopup}
          animationType={"slide"}
          transparent={true}
          onRequestClose={() => {
            setEditPopup(false);
          }}
        >
          <View
            style={
              isMobile
                ? {
                    backgroundColor: "white",
                    borderColor: "#eee",
                    borderRadius: 10,
                    borderWidth: 1,
                    height: "auto",
                    margin: "auto",
                    padding: 30,
                    shadowOffset: {
                      width: 0,
                      height: 2,
                    },
                    shadowOpacity: 0.25,
                    shadowRadius: 4,
                    elevation: 5,
                    width: "80%",
                  }
                : [styles.contanerSwitch]
            }
          >
            <TouchableOpacity
              style={{ alignSelf: "flex-end" }}
              onPress={() => setEditPopup(false)}
            >
              <IconCross
                name="circle-with-cross"
                size={20}
                color="#000"
                style={{ bottom: 5, top: 0 }}
              />
            </TouchableOpacity>

            <Text style={[styles.tableHead, { marginBottom: 20 }]}>
              Do You Want Update Status
            </Text>
            <View
              style={{
                flexDirection: "row",
                paddingRight: 10,
                justifyContent: "space-between",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  (setEditPopup(false), toggleSwitch());
                }}
                style={styles.saveBtn}
              >
                <Text style={{ color: "white" }}>Yes</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  setEditPopup(false);
                }}
                style={styles.saveBtn}
              >
                <Text style={{ color: "white" }}>No</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>
        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  marginTop: 20,
                  marginLeft: "-35%",
                  width: "170%",
                  flex: 1,
                }
              : { alignItems: "center", flex: 0.6 }
          }
        >
          <TextInput
            style={
              isMobile
                ? {
                    height: 35,
                    borderWidth: 2,
                    paddingLeft: 10,
                    borderColor: "#319ef0",
                    backgroundColor: "#FFFFFF",
                    width: "50%",
                    borderRadius: 5,
                    color: "#000",
                    fontWeight: "400",
                  }
                : styles.textInputStyle
            }
            onChangeText={(text) => searchFilterFunction(text)}
            value={searchData}
            underlineColor={"white"}
            theme={{
              colors: {
                text: "black",
                primary: "white",
                background: "transparent",
              },
            }}
            underlineColorAndroid="transparent"
            placeholder="Search Omega Devices"
            left={
              <TextInput.Icon
                name={() => <IconEdit name="search" size={20} color="#000" />} 
              />
            }
          />
        </View>
       
      </View>
      <View style={{ flexDirection: "row", width: "100%" }}>
        <View style={{ flex: 1 }}>
         
        </View>
      </View>

      <View
        style={
          isMobile
            ? { width: "100%", alignItems: "flex-end" }
            : { width: "100%", alignItems: "flex-end" }
        }
      >
        <TouchableOpacity
          style={
            isMobile
              ? [styles.addCountry, { width: "45%", marginRight: -10 }]
              : [styles.addCountry, { width: "10%" }]
          }
          onPress={() => {
            downloadExcelReport();
          }}
        >
          <Text style={styles.btnText}>
            <Icon name="exclefile1" size={15} color="#fff" /> Download
          </Text>
        </TouchableOpacity>
      </View>
     
      <View
        style={
          isMobile
            ? [styles.card, { flexGrow: 1, marginTop: 50, paddingBottom: 10 }]
            : [styles.card, { flexGrow: 1 }]
        }
      >
        <View
          style={[
            styles.shadowProp,
            {
              backgroundColor: "white",
            },
          ]}
        >
          <View
            style={{
              width: "100%",
              backgroundColor: "#F6F9F9",
            }}
          >
            <View
              style={
                isMobile
                  ? {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                      width: "140%",
                      alignSelf: "center",
                    }
                  : {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                      width: "100%",
                      alignSelf: "center",
                    }
              }
            >
              <View>
                {isLoading ? (
                  <ActivityIndicator
                    color="#1DA1F2"
                    visible={isLoading}
                    textContent={"Loading..."}
                    size={80}
                  />
                ) : (
                  <DataTable
                    columns={columns}
                    data={filterData}
                    customStyles={customStyles}
                    pagination
                  />
                )}
              </View>

            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  input: {
    borderColor: "gray",
    width: "60%",
    borderWidth: 1,
    borderRadius: 10,

    padding: 10,
  },
  tableHeader: {
    color: "#000",
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "700",
  },
  tableHead: {
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "400",
    color: "#000000",
  },
  addDevice: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  card: {
    width: "70%",
    flex: 1,
    marginVertical: 10,
  },
  contanerSwitch: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 5,
    alignSelf: "center",
    borderWidth: 1,
    height: "25%",
    margin: "auto",
    padding: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "30%",
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 18,
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    marginRight: 10,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 25,
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },
  textInputStyle: {
    height: 35,
    borderWidth: 2,
    paddingLeft: 10,
    margin: 0,
    borderColor: "#319ef0",
    backgroundColor: "#FFFFFF",
    width: "45%",
    borderRadius: 5,
    color: "#000",
    fontWeight: "400",
  },
  addCountry: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
  },
});
